export const USA_SPEC_SPORTS = [
  'Basketball',
  'IceHockey',
  'Baseball',
  'AustralianFootball',
  'RugbyLeague',
  'Darts',
  'Lacross',
  'AmericanFootball'
];

export const TWO_WAY_OUTCOME_SPORTS = [
  'Tennis',
  'Volleyball',
  'Cricket',
  'TableTennis',
  'Mma',
  'CounterStrike',
  '3x3Basketball',
  'Badminton',
  'Boxing',
  'Dota2',
  'BeachVolleyball',
  'LeagueOfLegends',
  'RainbowSix',
  'Squash',
  'StarCraft2',
  'Valorant',
  'Teqball',
  'Snooker',
  'Golf',
  'KingOfGlory',
  'HeroesOfTheStorm'
];

export const EU_TWO_WAY_OUTCOME_SPORTS = [
  ...TWO_WAY_OUTCOME_SPORTS,
  'IceHockey',
  'Basketball',
  'AmericanFootball',
  'Cricket',
  'Darts',
  'RugbyLeague',
  'RugbyUnion'
];
